import {XUtils} from '../utils/xp.v1';
const CONST = XUtils.getConst();

export * from './error'
export * from './jianding'

export const {
    CORP,
    CORP_XS,
    ENV_MODE,
    HOST_BBS,
    HOST_API,
    HOST_PAI,
    HOST_WEB,
    HOST_STATIC,
    HOST_PASSPORT
} = CONST